(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zh-TW", [], factory);
	else if(typeof exports === 'object')
		exports["zh-TW"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["zh-TW"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 